export { default as ar } from './ar.js';
export { default as bg } from './bg.js';
export { default as ca } from './ca.js';
export { default as cs } from './cs.js';
export { default as da } from './da.js';
export { default as de } from './de.js';
export { default as el } from './el.js';
export { default as enGB } from './en-GB.js';
export { default as enUS } from './en-US.js';
export { default as eo } from './eo.js';
export { default as es } from './es.js';
export { default as fi } from './fi.js';
export { default as fil } from './fil.js';
export { default as fr } from './fr.js';
export { default as frCH } from './fr-CH.js';
export { default as hr } from './hr.js';
export { default as id } from './id.js';
export { default as is } from './is.js';
export { default as it } from './it.js';
export { default as ja } from './ja.js';
export { default as ko } from './ko.js';
export { default as mk } from './mk.js';
export { default as nb } from './nb.js';
export { default as nl } from './nl.js';
export { default as pl } from './pl.js';
export { default as pt } from './pt.js';
export { default as ro } from './ro.js';
export { default as ru } from './ru.js';
export { default as sk } from './sk.js';
export { default as sv } from './sv.js';
export { default as th } from './th.js';
export { default as tr } from './tr.js';
export { default as ua } from './ua.js';
export { default as vi } from './vi.js';
export { default as zhCN } from './zh-CN.js';
export { default as zhTW } from './zh-TW.js';